module.exports = "<!--<div class=\"loading-indicator\">-->\n<!--  <mat-progress-spinner mode=\"indeterminate\"></mat-progress-spinner>-->\n<!--</div>-->\n"